import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const TimestampTheme = {
    timestamp: {
        light: {
            background: {
                color: Colors.white,
                backgroundColor: withOpacity(Colors.black, Opacities.medium),
            },
            color: Colors.black,
        },
        dark: {
            // as described in the guidelines this is not allowed to use, so therefore we use the light theme
            background: {
                color: Colors.white,
                backgroundColor: withOpacity(Colors.black, Opacities.medium),
            },
            color: Colors.white,
        },
    },
};
export default TimestampTheme;
